/* loaded by smart-asset */
export default require("./last_page-24px~tJoDbqnT.svg")